import { useMemo } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import { ChatPermissions, existingChatPermissions } from '@/core/chat/chat-keys/key';

export default function KeyFormView({
  newKeyPermissions,
  setNewKeyPermissions,
  onSave,
  newKeyName,
  setNewKeyName,
  userChatPermissions,
  onCancel,
}: {
  newKeyPermissions: ChatPermissions[];
  setNewKeyPermissions: React.Dispatch<React.SetStateAction<ChatPermissions[]>>;
  onSave: () => void;
  newKeyName: string;
  setNewKeyName: React.Dispatch<React.SetStateAction<string>>;
  userChatPermissions: ChatPermissions[];
  onCancel: () => void;
}) {
  return (
    <div className="container-element">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div className="d-flex align-items-center gap-3">
          <FontAwesomeIcon icon={faArrowLeft} onClick={onCancel} />
          <h3 className="mb-0">Create New Key</h3>
        </div>
        <button
          disabled={!newKeyName || newKeyPermissions.length === 0}
          className="btn btn-tertiary text-base-light"
          onClick={onSave}
        >
          Save
        </button>
      </div>

      <KeyForm
        userChatPermissions={userChatPermissions}
        keyPermissions={newKeyPermissions}
        setKeyPermissions={setNewKeyPermissions}
        keyName={newKeyName}
        setKeyName={setNewKeyName}
      />
    </div>
  );
}

export const KeyForm = ({
  userChatPermissions,
  keyPermissions,
  setKeyPermissions,
  keyName,
  setKeyName,
}: {
  userChatPermissions: ChatPermissions[];
  keyPermissions: ChatPermissions[];
  setKeyPermissions: React.Dispatch<React.SetStateAction<ChatPermissions[]>>;
  keyName: string;
  setKeyName: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const togglePermission = (perm: ChatPermissions) => {
    setKeyPermissions(prev =>
      prev.includes(perm) ? prev.filter(p => p !== perm) : [...prev, perm],
    );
  };
  const sortedPermissions = useMemo(
    () => [...existingChatPermissions].sort((a, b) => a.name.localeCompare(b.name)),
    [],
  );
  return (
    <>
      <div className="mb-3">
        <label className="form-label">Name</label>
        <input
          className="form-control"
          value={keyName}
          onChange={e => setKeyName(e.target.value)}
        />
      </div>
      <div className="mb-4 small text-muted">
        Select the permissions that this key will grant. Only the chats for which you have access
        will be available.
      </div>
      <div className="row">
        {sortedPermissions.map(perm => (
          <div className="col-12 col-sm-6 col-md-4 mb-1" key={perm.id}>
            <OverlayTrigger
              placement="left"
              overlay={
                !userChatPermissions.includes(perm.id) ? (
                  <Tooltip>You don't have permissions for this chat</Tooltip>
                ) : (
                  <></>
                )
              }
            >
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  disabled={!userChatPermissions.includes(perm.id ?? '')}
                  checked={keyPermissions.includes(perm.id)}
                  onChange={() => togglePermission(perm.id)}
                />
                <label className="form-check-label small">{perm.name}</label>
              </div>
            </OverlayTrigger>
          </div>
        ))}
      </div>
    </>
  );
};
